import { useState } from "react";
import { REGION_TYPES } from "@/sim/lib";
import { cn } from "@/lib/utils";

export function HeatmapOverlay({ image, regions = [], dims, failed = false }) {
  const [active, setActive] = useState({ gaze: true, tap: true, friction: true });
  const [show, setShow] = useState(true);
  const types = Array.from(new Set(regions.map((r) => r.type)));

  return (
    <div className="sim-card rounded-xl overflow-hidden" data-testid="sim-canvas">
      <div className="flex items-center justify-between px-3 py-2 border-b border-[#27272A]">
        <span className="sim-mono text-[11px] text-[#D4D4D8] uppercase tracking-wider">Simulation Canvas</span>
        <div className="flex items-center gap-1.5">
          {types.map((t) => (
            <button
              key={t}
              data-testid={`sim-heat-toggle-${t}`}
              onClick={() => setActive((a) => ({ ...a, [t]: !a[t] }))}
              className={cn("sim-mono text-[10px] px-2 py-0.5 rounded border transition-colors flex items-center gap-1",
                active[t] ? "border-white/20 text-[#F5F5F5]" : "border-[#27272A] text-[#9AA0AC]")}
            >
              <span className="w-2 h-2 rounded-full" style={{ background: `rgb(${REGION_TYPES[t]?.color || "255,255,255"})` }} />
              {REGION_TYPES[t]?.label || t}
            </button>
          ))}
          <button
            data-testid="sim-heat-master"
            onClick={() => setShow((s) => !s)}
            className={cn("sim-mono text-[10px] px-2 py-0.5 rounded border transition-colors",
              show ? "border-[#00F0FF]/40 text-[#00F0FF]" : "border-[#27272A] text-[#9AA0AC]")}
          >
            {show ? "HEATMAP ON" : "HEATMAP OFF"}
          </button>
        </div>
      </div>
      <div className="relative bg-[#060606] max-h-[520px] overflow-auto sim-scroll">
        {image ? (
          <div className="relative w-full">
            <img src={image} alt="target page" className="w-full block" data-testid="sim-screenshot" />
            {show && regions.filter((r) => active[r.type]).map((r, i) => (
              <div
                key={`${r.type}-${i}`}
                className="sim-heat absolute"
                style={{
                  left: `${r.x * 100}%`, top: `${r.y * 100}%`,
                  width: `${Math.max(r.w, 0.12) * 100}%`, height: `${Math.max(r.h, 0.08) * 100}%`,
                  background: `radial-gradient(circle, rgba(${REGION_TYPES[r.type]?.color || "0,240,255"},${0.4 + r.weight * 0.45}) 0%, rgba(${REGION_TYPES[r.type]?.color || "0,240,255"},${0.15 + r.weight * 0.2}) 45%, transparent 72%)`,
                  opacity: 0.72 + r.weight * 0.28,
                }}
              />
            ))}
          </div>
        ) : (
          <div className="h-[360px] flex items-center justify-center">
            {failed ? (
              <div className="text-center">
                <div className="w-10 h-10 rounded-md border border-[#27272A] flex items-center justify-center mx-auto mb-3">
                  <span className="sim-mono text-[#9AA0AC] text-lg">×</span>
                </div>
                <p className="sim-mono text-[11px] text-[#9AA0AC]">NO RENDER AVAILABLE</p>
              </div>
            ) : (
              <div className="text-center">
                <div className="w-10 h-10 border-2 border-[#00F0FF]/30 border-t-[#00F0FF] rounded-full animate-spin mx-auto mb-3" />
                <p className="sim-mono text-[11px] text-[#C2C5CE]">RENDERING TARGET PAGE…</p>
              </div>
            )}
          </div>
        )}
      </div>
      {dims && (
        <div className="px-3 py-1.5 border-t border-[#27272A]">
          <span className="sim-mono text-[10px] text-[#9AA0AC]">{dims.width}×{dims.height} · {dims.device}</span>
        </div>
      )}
    </div>
  );
}
